import React, {Fragment} from "react";

import {useTranslation} from "react-i18next";

const DrinkContains = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <div className="drink_contains">
                <span>1. {t("drink_contains:konservierungsstoff")} / </span>
                <span>2. {t("drink_contains:mit_geschmacksverstärker")} / </span>
                <span>3. {t("drink_contains:mit_antioxidationsmittel")} / </span>
                <span>4. {t("drink_contains:mit_farbstoff")} / </span>
                <span>5. {t("drink_contains:mit_phosphat")} / </span>
                <span>6. {t("drink_contains:mit_süßungsmittel")} / </span>
                <span>7. {t("drink_contains:mit_koffein")} / </span>
                <span>8. {t("drink_contains:chininhaltig")} / </span>
                <span>9. {t("drink_contains:taurinhaltig")} / </span>
                <span>11. {t("drink_contains:mit_aromastoffen")} / </span>
                <span>11. {t("drink_contains:säuerungsmittel")}</span>
            </div>
        </Fragment>
    );
};

export default DrinkContains;
